import { Injectable } from '@angular/core';
import { DocumentRefService } from '@core/services/helpers/document-ref.service';

@Injectable()
export class FullscreenService {
    get isFullscreenMode(): boolean {
        return this.documentRefService.isFullscreenMode();
    }

    constructor(private documentRefService: DocumentRefService) {}

    start(element: HTMLElement) {
        element.requestFullscreen().catch(() => {});
    }

    exit() {
        this.documentRefService.exitFullscreen();
    }
}
